import React from 'react';

interface BackupJobStatusProps {
  job: {
    id: string;
    status: string;
    total: number;
    completed: number;
    errors: string[];
  } | null;
  onHide: () => void;
}

const BackupJobStatus: React.FC<BackupJobStatusProps> = ({ job, onHide }) => {
  if (!job) return null;

  return (
    <div className="p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded">
      <div className="flex items-center justify-between">
        <div className="text-sm text-blue-800 dark:text-blue-200">
          Backup job {job.id}: {job.status} — {job.completed}/{job.total}
          {job.errors?.length ? `, errors: ${job.errors.length}` : ''}
        </div>
        {job.status === 'running' && (
          <button className="text-sm text-blue-700" onClick={onHide}>
            Hide
          </button>
        )}
      </div>
    </div>
  );
};

export default BackupJobStatus;